module.exports = __webpack_public_path__ + "media/images/novem-exclusive-bg-3d20e5df02252201a5d74d5776d93c11.png";